import type { ContractOutput, ContractResult } from '@/shared/types/phase-contracts';

export function deriveScope(score: number): 1 | 2 | 3 | 4 | 5 {
  if (score >= 80) return 5;
  if (score >= 60) return 4;
  if (score >= 40) return 3;
  if (score >= 20) return 2;
  return 1;
}

export function deriveDeadline(trackD: number): number {
  return Math.max(8, Math.min(20, 10 + trackD));
}

export function deriveWorkload(trackS: number): number {
  return Math.max(400, Math.min(1200, 600 + trackS * 100));
}

export function deriveBudget(trackB: number): number {
  return Math.max(500, Math.min(2500, 1000 + trackB * 200));
}

export function derivePenalty(trackL: number): number {
  return Math.max(0, Math.min(1000, 200 + trackL * 150));
}

export function deriveContractType(
  output: ContractOutput,
): 'STANDARD' | 'IMPATIENT' | 'LEGACY' {
  const tags = output.contractTags;
  if (tags.includes('legacy') || tags.includes('tech_debt')) return 'LEGACY';
  if (tags.includes('urgent') || tags.includes('deadline_pressure'))
    return 'IMPATIENT';
  return 'STANDARD';
}

export function mapContractOutputToContractResult(
  output: ContractOutput,
  projectId: string,
  projectName: string,
): ContractResult {
  const budget = deriveBudget(output.tracksFinal.B);
  return {
    project: {
      projectId,
      name: projectName,
      scope: deriveScope(output.score),
      deadline: deriveDeadline(output.tracksFinal.D),
      workload: deriveWorkload(output.tracksFinal.S),
      budget,
      deposit: Math.round(budget * 0.3),
      completionBonus: Math.round(budget * 0.7),
      penalty: derivePenalty(output.tracksFinal.L),
      type: deriveContractType(output),
    },
  };
}
